<template>
  <section>
    <fixed-header title="Unpublished to Quickbooks" hideNewOfferBtn />
    <b-card>
      <b-card-body>
        <b-tabs>
          <b-tab title="Invoices" active v-if="checkClaim(CAN_VIEW_ALL_INVOICES)">
            <invoices isAccountPage isUnpublishedQboPage :gridId="invoiceGridId" />
          </b-tab>
          <b-tab title="Purchase Orders" v-if="checkClaim(CAN_VIEW_ALL_POS)">
            <purchase-orders isAccountPage isUnpublishedQboPage :gridId="poGridId" />
          </b-tab>
          <b-tab title="Work Orders" v-if="checkClaim(CAN_VIEW_ALL_WORK_ORDERS)">
            <service-orders isAccountPage isUnpublishedQboPage :gridId="woGridId" />
          </b-tab>
        </b-tabs>
      </b-card-body>

    </b-card>

  </section>
</template>

<script>
import FixedHeader from '@/shared/components/FixedHeader/indexNew';
import Invoices from '@/shared/components/Invoices';
import PurchaseOrders from '@/shared/components/PurchaseOrders';
import ServiceOrders from '@/shared/components/ServiceOrders';
import {GRID_ID} from '@/shared/constants';
 
export default {
  components: {
    FixedHeader,
    Invoices,
    PurchaseOrders,
    ServiceOrders
  },
  metaInfo: () => ({
    title: 'Unpublished to QBO',
  }),
  data() {
    return {
      invoiceGridId: GRID_ID.QBO_UNPUBLISHED_INVOICE,
      poGridId: GRID_ID.QBO_UNPUBLISHED_PURCHASE_ORDER,
      woGridId: GRID_ID.QBO_UNPUBLISHED_WORK_ORDER
    }
  }
}
</script>